<template>
  <span class="navbar-burger" :class="{'is-active': mobileVisible}" @click="toggle">
    <span/>
    <span/>
    <span/>
  </span>
</template>

<script>
export default {
  data(){
    return this.$parent._data
  },

  methods: {
    toggle(){
      this.$parent.toggle()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/frontend/menu/MobileToggle.vue